export default {
  'settings.account.title': 'Account settings',
  'settings.account.personalData': 'Personal data',
  'settings.account.personalData.name': 'Name',
  'settings.account.personalData.email': 'E-mail',
  'settings.account.personalData.submit': 'Submit',

  'settings.account.accessData': 'Access credentials',
  'settings.account.accessData.login': 'Login',
  'settings.account.accessData.oldPassword': 'Old Password',
  'settings.account.accessData.newPassword': 'New Password',
  'settings.account.accessData.passwordVerify': 'Verify Password',
  'settings.account.accessData.message.password.required':
    'Enter user password',
  'settings.account.accessData.message.password.min':
    'Password must have at least 8 characters',
  'settings.account.accessData.message.password.verify': 'Passwords must match',
  'settings.account.accessData.submit': 'Submit',

  'settings.account.personalData.notification.success.title':
    'Successfully changed data!',
  'settings.account.personalData.notification.success.description':
    'User information has been updated successfully!',
  'settings.account.personalData.notification.error.title':
    'Error changing data',
  'settings.account.personalData.notification.error.description':
    'An error occurred while changing user data.',

  'settings.account.accessData.notification.success.title':
    'Password changed successfully!',
  'settings.account.accessData.notification.success.description':
    'User password has been changed successfully!',
  'settings.account.accessData.notification.error.title':
    'Error changing password!',
  'settings.account.accessData.notification.error.description':
    'An error occurred while changing the password.',

  'settings.workorderConfiguration.title': 'Workorder Setting',
  'settings.workorderConfiguration.description':
    "The following selected items will be used as columns in the system's workorder tables. This setting is only for your current user.",

  'settings.workorderConfiguration.domain.enums.work_order_field_options.none':
    'None',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.number':
    'Number',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.company':
    'Company',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.estimator':
    'Estimator',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.customer':
    'Customer',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.insurer':
    'Insurer',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.plate':
    'Plate',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.vehicle':
    'Vehicle',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.observation':
    'Observation',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.estimated_leave_date':
    'Estimated Leave Date',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.entry_date':
    'Entry Date',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.authorization_date':
    'Authorization Date',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.close_date':
    'Close Date',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.return_date':
    'Delivery Date',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.status':
    'Situation',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.type':
    'Type',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.cost':
    'Cost',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.localiza':
    'Localiza',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.commission':
    'Commission',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.complement_tag':
    'Tag',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.situation':
    'Status',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.prisma':
    'Prisma',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.fleet':
    'Fleet',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.porto_battery':
    'Battery (7051)',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.porto_battery_warranty':
    'Battery warranty',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.chassi':
    'Chassi',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.motorization':
    'Motorization',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.complement_origin':
    'Complement origin',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.schedule_date':
    'Shedule date',
  'settings.workorderConfiguration.update.success': 'Success',
  'settings.workorderConfiguration.update.success.description':
    'Profile updated.',

  'settings.partsConfiguration': 'Parts Configuration',
  'settings.partsConfiguration.description':
    "The following selected items will be used as columns in the system's parts table listings. This setting is only for your current user.",

  'settings.partsConfiguration.domain.enums.item_field_options.none': 'None',
  'settings.partsConfiguration.domain.enums.item_field_options.bar_code':
    'Bar Code',
  'settings.partsConfiguration.domain.enums.item_field_options.manufacturing_code':
    'Manufacturing Code',
  'settings.partsConfiguration.domain.enums.item_field_options.original_code':
    'Original Code',
  'settings.partsConfiguration.domain.enums.item_field_options.description':
    'Description',
  'settings.partsConfiguration.domain.enums.item_field_options.available_stock':
    'Available Stock',
  'settings.partsConfiguration.domain.enums.item_field_options.total_stock':
    'Total Stock',
  'settings.partsConfiguration.domain.enums.item_field_options.manufacturer':
    'Manufacturer',
  'settings.partsConfiguration.domain.enums.item_field_options.group': 'Group',
  'settings.partsConfiguration.domain.enums.item_field_options.sell_price':
    'Sell Price',
  'settings.partsConfiguration.domain.enums.item_field_options.location':
    'Location',
  'settings.partsConfiguration.domain.enums.item_field_options.image': 'Image',
  'settings.partsConfiguration.domain.enums.item_field_options.applications':
    'Applications',

  'settings.partsConfiguration.update.success': 'Success',
  'settings.partsConfiguration.update.success.description': 'Profile updated.',

  'settings.system.title': 'System settings',
  'settings.system.systemLanguage': 'System language',
  'settings.system.systemLanguage.language': 'Language',

  'settings.registration.systemMasks': 'System Masks',
  'settings.registration.maskPlanAccount':
    'Chart of accounts mask (Example: 9999.9999)',
  'settings.financialConfiguration.domain.enums.financial_field_options.code':
    'Code',
  'settings.financialConfiguration.domain.enums.financial_field_options.company':
    'Company',
  'settings.financialConfiguration.domain.enums.financial_field_options.debtor_and_creditor':
    'Debtor/Creditor',
  'settings.financialConfiguration.domain.enums.financial_field_options.description':
    'Description',
  'settings.financialConfiguration.domain.enums.financial_field_options.document_type':
    'Document type',
  'settings.financialConfiguration.domain.enums.financial_field_options.due_date':
    'Due date',
  'settings.financialConfiguration.domain.enums.financial_field_options.pay_date':
    'Pay date',
  'settings.financialConfiguration.domain.enums.financial_field_options.emission_date':
    'Emission date',
  'settings.financialConfiguration.domain.enums.financial_field_options.situation':
    'Situation',
  'settings.financialConfiguration.domain.enums.financial_field_options.value':
    'Value',
  'settings.financialConfiguration.domain.enums.financial_field_options.document_number':
    'Document number',
  'settings.financialConfiguration.domain.enums.financial_field_options.installment_tag':
    'Installment tag',
  'settings.financialConfiguration.domain.enums.financial_field_options.authorization_number':
    'Authorization number',
};
